// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".work-orders-manager-form-grid[data-v-6e55f464]{height:30rem !important}hr[data-v-6e55f464]{margin:1rem 1rem 2rem 1rem !important;border-top:1px solid rgba(224,224,224,.97)}", ""]);
// Exports
module.exports = exports;
